import ajax from '../../lib/ajax';
import util from '../../lib/util'
import {Store,Module,ActionContext} from 'vuex'
import appConst from "@/lib/appconst"
import _ from "lodash"
interface SessionState{
    application:any,
    user:any,
    tenant:any
}

interface sessionInitParam{
    type:string,
    userId:string,
}

class SessionStore implements Module<SessionState,any>{
    namespaced=true;
    state={
        application:null,
        user:null,
        tenant:null
    }
    mutations = {
      setUserAvator(state:SessionState,info:any){
          if(info.avatar){
              info.avatar = appConst.fileResourceUrl + info.avatar;
              state.user.avatar = info.avatar;
          }
          state.user.nickname = info.nickname;

      }
    }
    actions={
        async init(content:ActionContext<SessionState,any>, param:sessionInitParam){
            if(param.userId!=undefined && param.userId!='0'){
                let rep=await ajax.get('web/user/GetLoginUserInfo');
                let errno = rep.data.errno;
                if(errno!=0){
                    return;
                }
                let userInfo = _.extend({
                    userId:param.userId
                })
                userInfo = _.extend(userInfo,rep.data.data)
                content.state.user= userInfo;
                // if(content.state.user.avatar){
                //     content.state.user.avatar = appConst.fileResourceUrl + content.state.user.avatar;
                // }
            }

            // content.state.tenant=rep.data.result.tenant;
        }
    }
}
const session=new SessionStore();
export default session;
